import { RichTextHTMLString } from '../sections/types';

type Props = {
  html: RichTextHTMLString;
  tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};
export const RichTextHeading = ({ html, tag, ...rest }: Props) => {
  const Tag = tag;
  return (
    <Tag
      dangerouslySetInnerHTML={{
        __html: html.replace(/<\/?(p|h[1-6])>/g, ''),
      }}
      {...rest}
    />
  );
};
